import React, { useState } from "react";
import {
  Button,
  Grid,
  Paper as MuiPaper,
  TextField,
  Typography,
} from "@mui/material";
import WithdrawInfo from "./WithdrawInfo";
import styled from "styled-components/macro";
import { spacing, sizing } from "@mui/system";
import convertUSD from "../../../utils/convertUSD";

const Paper = styled(MuiPaper)`
  ${spacing} ${sizing}
`;

const WithdrawStep2 = ({
  loading,
  withdraw,
  withdrawOptions,
  user,
  userOptions,
  onPrevious,
  onNext,
  previousDisabled,
  nextDisabled,
}) => {
  const [amountAsCheck, setAmountAsCheck] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [checkNumber, setCheckNumber] = useState("");
  const [date, setDate] = useState("");

  return (
    <>
      <Grid item xs={12}>
        <Grid container spacing={2} alignItems="stretch">
          <Grid item xs={12} md={6}>
            <Paper p={4} height="100%" elevation={0}>
              <Grid container spacing={4}>
                <Grid item xs={12} sm={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <WithdrawInfo
                        loading={loading}
                        title="User Status"
                        value={
                          userOptions?.status?.find(
                            (status) => status.value === user.status
                          )?.display_name
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <WithdrawInfo
                        loading={loading}
                        title="User Real Cash Amount"
                        value={convertUSD(user.cash)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <WithdrawInfo
                        loading={loading}
                        title="User Bonus Cash Amount"
                        value={convertUSD(user.bonusCash)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <WithdrawInfo
                        loading={loading}
                        title="User Total Cash Amount"
                        value={convertUSD(user.cashSum)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <WithdrawInfo
                        loading={loading}
                        title="Amount Requested by User"
                        value={convertUSD(withdraw.amount)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        value={amountAsCheck}
                        onChange={(event) =>
                          setAmountAsCheck(event.target.value)
                        }
                        label="Amount as Check"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <WithdrawInfo
                        loading={loading}
                        title="Amount as Withdraw"
                        value={convertUSD(withdraw.amountAsRefund)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <WithdrawInfo
                        loading={loading}
                        title="Amount as Paypal"
                        value={convertUSD(withdraw.amountAsPaypal)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper p={4} height="100%" elevation={0}>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={12}>
                      <Typography variant="h5">Check Information</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid container spacing={4}>
                        <Grid item xs={12} sm={4} md={6} lg={4}>
                          <TextField
                            value={accountNumber}
                            onChange={(event) =>
                              setAccountNumber(event.target.value)
                            }
                            label="Account Number"
                            size="small"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6} lg={4}>
                          <TextField
                            value={checkNumber}
                            onChange={(event) =>
                              setCheckNumber(event.target.value)
                            }
                            label="Check Number"
                            size="small"
                            fullWidth
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={6} lg={4}>
                          <TextField
                            value={date}
                            onChange={(event) => setDate(event.target.value)}
                            label="Date"
                            helperText="04/04/22"
                            size="small"
                            fullWidth
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={4}>
                    <Grid item xs={12}>
                      <Typography variant="h5">
                        Basic User Information
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={6} lg={4}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="ZenDesk Ticket ID"
                            value={withdraw.zendeskTicketId}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="User ID"
                            value={withdraw.userId}
                            link={`/users/${withdraw.userId}`}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="User Name"
                            value={user.name}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="Amount Requested by User"
                            value={convertUSD(withdraw.amount)}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="PayPal Email"
                            value={user.paypalEmail}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4} md={6} lg={4}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="User Email"
                            value={user.email}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="First Name"
                            value={user.firstName}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="Last Name"
                            value={user.lastName}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="Street Address"
                            value={user.streetAddress}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="Street Address 2"
                            value={user.streetAddressSecond}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={4} md={6} lg={4}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="Country"
                            value={user.country}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="City"
                            value={user.city}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="State/Province"
                            value={user.state}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <WithdrawInfo
                            loading={loading}
                            title="Postal Code"
                            value={user.postalCode}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Paper p={4} elevation={0}>
          <Grid container spacing={4} alignItems="center">
            <Grid item>
              <Button
                size="small"
                variant="text"
                color="primary"
                disabled={loading || previousDisabled}
                onClick={onPrevious}
              >
                Previous Step
              </Button>
            </Grid>
            <Grid item>
              <Button
                size="small"
                variant="contained"
                color="primary"
                disabled={loading || nextDisabled}
                onClick={onNext}
              >
                Next Step
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default WithdrawStep2;
